import GenericModel from '../generic-model';
import { Telephone } from '../telephone';
import Contact from '../Contact/contact';
import PMSColor from './pmscolor';
import AddressWithType from '../project/address-with-type';
import PaymentTerm from './payment-term';
import { Email } from '../email';
import ProjectInvoice from '../invoice/project-invoice';
import Asset from '../asset';

export default class Company extends GenericModel {
  archived?: boolean;
  name?: string;
  regularName?: string;
  contacts?: Contact[];
  telephones: Telephone[];
  emails?: Email[];
  immoscoop?: boolean;
  spotto?: boolean;
  colorsExtraInfo?: string;
  pmsColors?: PMSColor[];
  dataCorrect?: boolean;
  addresses?: AddressWithType[];
  customerSince?: Date;
  vat_number?: string;
  payment_term?: PaymentTerm;
  invoicePerEmail?: boolean;
  pendingInvoices?: boolean;
  immo?: boolean;
  activity?: string;
  mailNewsletter?: boolean;
  openHours?: string;
  info?: string;
  website?: string;
  discountGroup?: DiscountGroup;
  distanceTo?: number;
  projectInvoices?: ProjectInvoice[];
  isRetailer?: boolean;
  logo?: Asset;
  immobordImage?: Asset;
  kleefbordImage?: Asset;
  newPortalAccess: boolean;
  externalId?: string;
  partnerIntegrations?: string[];

  constructor() {
    super();
    this.telephones = [];
  }
}

export enum DiscountGroup {
  AAA = 'AAA',
  AA = 'AA',
  A = 'A',
  B = 'B',
  C = 'C',
}

export const COUNTRY_CHOICES = [
  {
    value: 'BE',
    label: 'België',
  },
  {
    value: 'NL',
    label: 'Nederland',
  },
  {
    value: 'LU',
    label: 'Luxemburg',
  },
  {
    value: 'DE',
    label: 'Duitsland',
  },
  {
    value: 'FR',
    label: 'Frankrijk',
  },
];
